<template>
  <nav
    class="navbar fixed-top d-flex justify-content-between"
    style="padding: 0 0 0 20px"
  >
    <b-skeleton-wrapper :loading="!CurrentUser.full_name" class="flex-fill">
      <template #loading>
        <div class="w-100 d-flex">
          <b-skeleton class="w-10 ml-3 my-auto" />
          <div class="flex-fill align-items-center text-center">
            <img
              src="../../assets/img/logo-small.png"
              class="logo mt-2"
              style="opacity: 20%"
            />
          </div>
          <b-skeleton class="w-10 my-auto" />

          <b-skeleton type="avatar" class="my-auto ml-3" />
        </div>
      </template>
      <a
        href="#"
        class="menu-button d-none d-md-block my-auto"
        @click.prevent.stop="toggleSideMenuStatus"
        ><menu-icon
      /></a>
      <a
        href="#"
        class="menu-button-mobile d-xs-block d-sm-block d-md-none ml-2"
        @click.prevent.stop="toggleSideMenuForMobile"
        ><mobile-menu-icon
      /></a>

      <div class="d-flex">
        <b-form-group
          label="جستجوی مدرسه (فقط نام)"
          class="has-float-label my-auto"
          v-show="this.$route.fullPath === '/school'"
        >
          <b-input
            v-model="school_q"
            @keyup.enter="searchSchool"
            type="search"
          />
        </b-form-group>
        <label
          class="text-danger border my-auto ml-1"
          style="border-radius: 20px; padding: 2px 7px 0 7px; cursor: pointer"
          v-show="this.$route.fullPath === '/school' && Menu.q_school.length"
          @click="clearSearchSchool"
          >×</label
        >
      </div>

      <div class="d-flex">
        <b-form-group
          label="جستجوی دانش‌آموز"
          class="has-float-label my-auto"
          v-show="this.$route.fullPath === '/student'"
        >
          <b-input
            v-model="student_q"
            @keyup.enter="searchStudent"
            type="search"
          />
        </b-form-group>
        <label
          class="text-danger border my-auto ml-1"
          style="border-radius: 20px; padding: 2px 7px 0 7px; cursor: pointer"
          v-show="this.$route.fullPath === '/student' && Menu.q_student.length"
          @click="clearSearchStudent"
          >×</label
        >
      </div>

      <div class="d-flex">
        <b-form-group
          label="جستجوی شبکه پشتیبان"
          class="has-float-label my-auto"
          v-show="this.$route.fullPath === '/mentor'"
        >
          <b-input
            v-model="mentor_q"
            @keyup.enter="searchMentor"
            type="search"
          />
        </b-form-group>
        <label
          class="text-danger border my-auto ml-1"
          style="border-radius: 20px; padding: 2px 7px 0 7px; cursor: pointer"
          v-show="this.$route.fullPath === '/mentor' && Menu.q_mentor.length"
          @click="clearSearchMentor"
          >×</label
        >
      </div>

      <div class="d-flex">
        <b-form-group
          label="جستجوی قرارگاه"
          class="has-float-label my-auto"
          v-show="this.$route.fullPath === '/platoon'"
        >
          <b-input
            v-model="platoon_q"
            @keyup.enter="searchPlatoon"
            type="search"
          />
        </b-form-group>
        <label
          class="text-danger border my-auto ml-1"
          style="border-radius: 20px; padding: 2px 7px 0 7px; cursor: pointer"
          v-show="this.$route.fullPath === '/platoon' && Menu.q_platoon.length"
          @click="clearSearchPlatoon"
          >×</label
        >
      </div>

      <div class="d-flex">
        <b-form-group
          label="جستجوی گروه"
          class="has-float-label my-auto"
          v-show="this.$route.fullPath === '/teams'"
        >
          <b-input v-model="team_q" @keyup.enter="searchTeam" />
        </b-form-group>
        <label
          class="text-danger border my-auto ml-1"
          style="border-radius: 20px; padding: 2px 7px 0 7px; cursor: pointer"
          v-show="this.$route.fullPath === '/teams' && Menu.q_team.length"
          @click="clearSearchTeam"
          >×</label
        >
      </div>

      <div class="flex-fill text-center my-auto d-none d-md-block">
        <router-link tag="a" to="/">
          <img src="../../assets/img/logo-small.png" class="logo mt-2" />
        </router-link>
      </div>
      <div class="header-icons d-inline-block align-middle mr-2">
        <div class="position-relative d-inline-block">
          <b-dropdown
            ref="header_icons"
            variant="empty"
            size="sm"
            right
            toggle-class="header-icon"
            menu-class="position-absolute mt-3 iconMenuDropdown"
            no-caret
          >
            <template slot="button-content">
              <i class="simple-icon-grid" />
            </template>
            <div @click="hideHeaderIcons">
              <router-link tag="a" to="/teams" class="icon-menu-item">
                <i class="icon-Mens d-block" />
                گروه‌ها
              </router-link>
              <router-link tag="a" to="/find-user" class="icon-menu-item">
                <i class="icon-Find-User d-block" />
                جستجوی کاربر
              </router-link>
              <router-link
                tag="a"
                to="/my-users"
                class="icon-menu-item"
                v-if="CurrentUser.province_limit && !CurrentUser.gender_limit"
              >
                <i class="iconsminds-male-female d-block" />
                کاربران من
              </router-link>
              <router-link tag="a" to="/about-us" class="icon-menu-item">
                <i class="icon-Information d-block" />
                درباره ما
              </router-link>
              <router-link
                tag="a"
                to="/election"
                class="icon-menu-item"
                v-if="
                  CurrentUser.roles && CurrentUser.roles.includes('مدیر سایت ')
                "
              >
                <i class="iconsminds-empty-box d-block" />
                انتخابات
              </router-link>
              <router-link
                tag="a"
                to="/manage"
                class="icon-menu-item"
                v-if="
                  CurrentUser.roles && CurrentUser.roles.includes('مدیر سایت ')
                "
              >
                <i class="iconsminds-equalizer d-block" />
                تنظیمات
              </router-link>
            </div>
          </b-dropdown>
        </div>
        <div class="position-relative d-none d-sm-inline-block">
          <div class="btn-group">
            <b-button
              variant="empty"
              class="header-icon btn-sm"
              @click="toggleFullScreen"
            >
              <i
                :class="{
                  'd-inline-block': true,
                  'simple-icon-size-actual': fullScreen,
                  'simple-icon-size-fullscreen': !fullScreen,
                }"
              />
            </b-button>
          </div>
        </div>
      </div>
      <div class="user d-inline-block">
        <b-dropdown
          class="dropdown-menu-right"
          right
          variant="empty"
          toggle-class="p-0"
          menu-class="mt-3"
          no-caret
        >
          <template slot="button-content">
            <span class="name mr-1">{{ CurrentUser.full_name }}</span>
            <span>
              <img
                :alt="CurrentUser.role"
                :src="BackendUrl + '/media/' + CurrentUser.photo_url"
                class="border"
              />
            </span>
          </template>
          <b-dropdown-item @click="gotoLink('/profile')">
            <div v-for="(role, i) in CurrentUser.roles">
              <svg height="10" width="10" class="mr-1">
                <circle cx="5" cy="5" r="5" fill="lightgray" /></svg
              >{{ role }}
            </div>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item @click="logout">خروج از سامانه</b-dropdown-item>
        </b-dropdown>
      </div>
    </b-skeleton-wrapper>
  </nav>
</template>

<script>
import Switches from "vue-switches";
import notifications from "../../data/notifications";
import { mapGetters, mapMutations } from "vuex";
import { MenuIcon, MobileMenuIcon } from "../../components/Svg";
import axios from "axios";
export default {
  components: {
    "menu-icon": MenuIcon,
    "mobile-menu-icon": MobileMenuIcon,
    switches: Switches,
  },
  data() {
    return {
      school_q: "",
      student_q: "",
      mentor_q: "",
      platoon_q: "",
      team_q: "",
      fullScreen: false,
      notifications,
    };
  },
  methods: {
    ...mapMutations(["toggleSideMenuStatus", "toggleSideMenuForMobile"]),
    logout() {
      this.$cookie.delete("userToken");
      this.$notify("info", "بدرود!", "شما از سامانه خارج شدید");
      this.$router.push("/login");
      this.$store.commit("setLogout");
      this.$store.commit("setSchoolPageIsUpdate", false);
      this.$store.commit("setStudentPageIsUpdate", false);
      this.$store.commit("setMentorPageIsUpdate", false);
      this.$store.commit("setPlatoonPageIsUpdate", false);
      this.$store.commit("setSchoolList", { list: [] });
      this.$store.commit("setStudentList", { list: [] });
      this.$store.commit("setMentorList", { list: [] });
      this.$store.commit("setPlatoonList", { list: [] });
      this.$store.commit("setTeamList", { list: [], total_count: 0 });
      this.$store.commit("setSchool", {
        editable: false,
        school: { slug: "" },
      });
      this.$store.commit("setUser", {});
      this.$store.commit("setPlatoon", { editable: false, slug: "" });
      document.title = "سامانه شهید باقری";
    },
    gotoLink(url) {
      this.$router.push(url);
    },
    toggleFullScreen() {
      const isInFullScreen = this.isInFullScreen();

      let docElm = document.documentElement;
      if (!isInFullScreen) {
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen();
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen();
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen();
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
      this.fullScreen = !isInFullScreen;
    },
    isInFullScreen() {
      return (
        (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement &&
          document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement &&
          document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null)
      );
    },
    searchSchool() {
      this.$store.commit("setSchoolQ", this.school_q);
      this.$store.commit("setSchoolPageIsUpdate", false);
      this.$store.dispatch("reloadSchoolList");
    },
    searchStudent() {
      this.$store.commit("setStudentQ", this.student_q);
      this.$store.commit("setStudentPageIsUpdate", false);
      this.$store.dispatch("reloadStudentList");
    },
    searchMentor() {
      this.$store.commit("setMentorQ", this.mentor_q);
      this.$store.commit("setMentorPageIsUpdate", false);
      this.$store.dispatch("reloadMentorList");
    },
    searchPlatoon() {
      this.$store.commit("setPlatoonQ", this.platoon_q);
      this.$store.commit("setPlatoonPageIsUpdate", false);
      this.$store.dispatch("reloadPlatoonList");
    },
    searchTeam() {
      this.$store.commit("setTeamQ", this.team_q);
      this.$store.commit("setTeamPageIsUpdate", false);
      this.$store.dispatch("reloadTeamList");
    },

    clearSearchSchool() {
      if (this.Menu.q_school.length) {
        this.school_q = "";
        this.$store.commit("setSchoolQ", "");
        this.$store.commit("setSchoolPageIsUpdate", false);
        this.$store.dispatch("reloadSchoolList");
      }
    },
    clearSearchStudent() {
      if (this.Menu.q_student.length) {
        this.student_q = "";
        this.$store.commit("setStudentQ", "");
        this.$store.commit("setStudentPageIsUpdate", false);
        this.$store.dispatch("reloadStudentList");
      }
    },
    clearSearchMentor() {
      if (this.Menu.q_mentor.length) {
        this.mentor_q = "";
        this.$store.commit("setMentorQ", "");
        this.$store.commit("setMentorPageIsUpdate", false);
        this.$store.dispatch("reloadMentorList");
      }
    },
    clearSearchPlatoon() {
      if (this.Menu.q_platoon.length) {
        this.platoon_q = "";
        this.$store.commit("setPlatoonQ", "");
        this.$store.commit("setPlatoonPageIsUpdate", false);
        this.$store.dispatch("reloadPlatoonList");
      }
    },
    clearSearchTeam() {
      if (this.Menu.q_team.length) {
        this.team_q = "";
        this.$store.commit("setTeamQ", "");
        this.$store.commit("setTeamPageIsUpdate", false);
        this.$store.dispatch("reloadTeamList");
      }
    },
    hideHeaderIcons() {
      this.$refs.header_icons.hide();
    },
  },
  computed: {
    ...mapGetters(["CurrentUser", "MenuType", "BackendUrl", "Menu"]),
  },
  created() {},
  watch: {
    "$i18n.locale"(to, from) {
      if (from !== to) {
        this.$router.go(this.$route.path);
      }
    },
  },
};
</script>
